import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useAlert } from 'react-alert'
import { Modal } from 'react-responsive-modal'
import { TwitterPicker } from 'react-color'
import * as actions from './actions'
import { InitialState } from './types'
import DatePicker from 'react-datepicker'
import moment from 'moment'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'

const customModalStyles = {
  root: {
    zIndex: 99999,
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
  },
  modal: {
    width: 650,
    borderRadius: 20,
    padding: 20,
    margin: '2em',
    boxShadow: 'unset',
    overflow: 'unset',
    outline: 0,
    backgroundColor: '#FFF',
  },
}

export default () => {
  const [title, setTitle] = useState<string>('')
  const [status, setStatus] = useState<string>('active')
  const [autoJoin, setAutoJoin] = useState<boolean>(false)
  const [startsAt, setStartsAt] = useState<Date>(new Date())
  const [createThemeModalIsOpen, setCreateThemeModalIsOpen] =
    useState<boolean>(false)
  const [selectedThemeId, setSelectedThemeId] = useState<string>('')
  const [color, setColor] = useState<string>('')
  const [titleTheme, setTitleTheme] = useState<string>('')
  const [statModal, setStatModal] = useState<boolean>(false)

  const { id } = useParams<{ id: string }>()

  const refUpload = useRef<HTMLInputElement | null>(null)
  const isMounted = useRef<boolean>(false)

  const dispatch = useDispatch()
  const alert = useAlert()

  const {
    page,
    isFetching,
    courseStatistic,
    themes,
    isFetchingThemes,
    isProcessSave,
    isProcessRemove,
    error,
  } = useSelector(
    (state: { adminCourseEdit: InitialState }) => state.adminCourseEdit
  )

  useEffect(() => {
    if (error) {
      alert.error(error)
    }
  }, [error])

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchCourse(id))
    dispatch(actions.fetchCourseStatistic(id))
    dispatch(actions.fetchThemes(id))
    isMounted.current = true
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (page && isMounted.current) {
      setAutoJoin(page.auto_subscription)
      setTitle(page.title)
      setStatus(page.status)
      setStartsAt(moment(page.starts_at).toDate())
    }
  }, [page])

  const onChangeTitle = (event: ChangeEvent<HTMLInputElement>) => {
    setTitle(event.currentTarget.value)
  }

  const onChangeStatus = (event: ChangeEvent<HTMLSelectElement>) => {
    setStatus(event.currentTarget.value)
  }

  const onChangeAutoJoin = (event: ChangeEvent<HTMLInputElement>) => {
    setAutoJoin(event.currentTarget.checked)
  }

  const onChangeThemeTitle = (event: ChangeEvent<HTMLInputElement>) => {
    setTitleTheme(event.currentTarget.value)
  }

  const handleEditCourse = () => {
    dispatch(actions.editCourse(id, title, status, startsAt, autoJoin))
  }

  const handleRemoveCourse = () => {
    dispatch(actions.removeCourse(id))
  }

  const onChangeColor = (color: string) => {
    setColor(color)
  }

  const handleOpenModalTheme = () => {
    setSelectedThemeId('')
    setTitleTheme('')
    setColor('')
    setCreateThemeModalIsOpen(true)
  }

  const handleCreateTheme = () => {
    if (titleTheme && color) {
      if (selectedThemeId) {
        dispatch(actions.editTheme(id, selectedThemeId, titleTheme, color))
      } else {
        dispatch(actions.createTheme(id, titleTheme, color))
      }
      setCreateThemeModalIsOpen(false)
    } else {
      alert.error('Необходимо заполнить все поля')
    }
  }

  const handleRemoveMap = (map_id: string) => {
    dispatch(actions.removeMap(id, map_id))
  }

  const handleOpenPicker = () => {
    if (refUpload.current) {
      refUpload.current?.click()
    }
  }

  const onChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0]
      dispatch(actions.createMap(id, file, '0'))
    }
  }

  return (
    <>
      <Header />
      <div className={'container'}>
        <h2>Панель администрирования - Редактирование курса</h2>
        <nav>
          <Link to={`/admin/courses/${id}/modules`}>Модули</Link> |{' '}
          <Link to={`/admin/courses/${id}/lessons`}>Уроки</Link>
        </nav>
        <br />
        <br />
        {!isMounted.current || isFetching ? (
          <span>Загрузка курса...</span>
        ) : (
          <>
            <label htmlFor={'title'}>Название курса:</label>
            <br />
            <input
              id={'title'}
              placeholder={'Введите название курса'}
              value={title}
              onChange={onChangeTitle}
              style={{ marginBottom: 10, width: 200 }}
              required={true}
            />
            <br />
            <label htmlFor={'status'}>Выберите статус:</label>
            <br />
            <select
              id={'status'}
              value={status}
              style={{ marginBottom: 10, width: 200 }}
              onChange={onChangeStatus}
            >
              <option value={'active'}>Активен</option>
              <option value={'inactive'}>Не активен</option>
            </select>
            <br />
            <label htmlFor={'date'}>Дата начала:</label>
            <br />
            <DatePicker
              locale={'ru'}
              selected={startsAt}
              onChange={(date: Date) => setStartsAt(date)}
              showTimeSelect={true}
              dateFormat={'Pp'}
            />
            <label style={{ display: 'block', margin: '10px 0' }}>
              <input
                checked={autoJoin}
                type={'checkbox'}
                onChange={onChangeAutoJoin}
              />{' '}
              Автоматически подписывать нового пользователя на курс
            </label>
            <button onClick={handleEditCourse}>Сохранить курс</button>
            <br />
            <br />
            <button
              style={{ background: 'red', color: '#FFF', opacity: 0.7 }}
              onClick={handleRemoveCourse}
              disabled={true}
            >
              Удалить курс
            </button>
            <br />
            <br />
            <button onClick={() => setStatModal(true)}>Статистика</button>
            <br />
            {page && page.modules?.length ? (
              <>
                <br />
                <h3>Модули:</h3>
                <ul>
                  {page.modules.map(module => (
                    <li key={module.module_id}>
                      <Link
                        to={`/admin/courses/${id}/modules/${module.module_id}`}
                      >
                        {module.title}
                      </Link>
                      <ul>
                        {module.lessons.map(lesson => (
                          <li key={lesson.lesson_id}>
                            <Link
                              to={`/admin/courses/${id}/lessons/${lesson.lesson_id}`}
                            >
                              {lesson.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <br />
            )}
            <br />
            {isFetchingThemes ? (
              <span>Загрузка тем уроков...</span>
            ) : (
              <h3>Темы уроков:</h3>
            )}
            {themes?.length ? (
              <table>
                <thead>
                  <tr>
                    <td>
                      <b>Заголовок</b>
                    </td>
                    <td>
                      <b>Цвет</b>
                    </td>
                    <td />
                    <td />
                  </tr>
                  {themes.map(theme => (
                    <tr key={theme.theme_id}>
                      <td>{theme.title}</td>
                      <td
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          height: 30,
                        }}
                      >
                        <div
                          style={{
                            background: theme.color,
                            width: 10,
                            height: 10,
                            borderRadius: 3,
                            marginRight: 5,
                          }}
                        />
                        {theme.color}
                      </td>
                      <td>
                        <button
                          onClick={() => {
                            setSelectedThemeId(theme.theme_id)
                            setTitleTheme(theme.title)
                            setColor(theme.color)
                            setCreateThemeModalIsOpen(true)
                          }}
                        >
                          Изменить
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() =>
                            dispatch(actions.removeTheme(id, theme.theme_id))
                          }
                          style={{ color: '#FFF', background: 'red' }}
                        >
                          X
                        </button>
                      </td>
                    </tr>
                  ))}
                </thead>
              </table>
            ) : null}
            <br />
            <button onClick={handleOpenModalTheme}>Добавить тему</button>
            <input
              ref={refUpload}
              style={{ display: 'none' }}
              type={'file'}
              onChange={onChangeFile}
            />
            <br />
            <br />
            <h3>Карты:</h3>
            <table style={{ width: '70%' }}>
              <thead>
                <tr>
                  <td style={{ textAlign: 'center' }}>№</td>
                  <td>Название файла</td>
                  <td>Статус</td>
                  <td />
                  <td />
                </tr>
              </thead>
              <tbody>
                {page &&
                  page.maps?.map((map, index) => (
                    <tr key={map.map_id}>
                      <td style={{ width: 30, textAlign: 'center' }}>
                        {index + 1}
                      </td>
                      <td>
                        <a
                          href={map.image_media.url}
                          target={'_blank'}
                          rel="noreferrer"
                        >
                          {map.image_media.name}
                        </a>
                      </td>
                      <td style={{ width: 100 }}>
                        <b>{map.is_active ? 'Активна' : 'Не активна'}</b>
                      </td>
                      <td style={{ width: 80 }}>
                        <Link to={`/admin/courses/${id}/maps/${map.map_id}`}>
                          <button>Настроить</button>
                        </Link>
                      </td>
                      <td style={{ width: 40, textAlign: 'center' }}>
                        <button
                          onClick={() => handleRemoveMap(map.map_id)}
                          style={{ background: 'red', color: '#FFF' }}
                        >
                          X
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <br />
            <button onClick={handleOpenPicker}>Добавить новую карту</button>
            <br />
            {error ? <span style={{ color: 'red' }}>{error}</span> : null}
            <br />
            {isProcessSave ? <span>Сохранение курса...</span> : null}
            <br />
            {isProcessRemove ? (
              <span style={{ color: 'red' }}>Удаление курса...</span>
            ) : null}
            <Modal
              open={createThemeModalIsOpen}
              onClose={() => setCreateThemeModalIsOpen(false)}
              styles={customModalStyles}
              center={true}
            >
              <h3 style={{ margin: 0, marginBottom: 10 }}>
                {selectedThemeId ? 'Изменить' : 'Добавить'} тему
              </h3>
              <label style={{ display: 'block', marginBottom: 5 }}>
                Заголовок:
              </label>
              <input
                style={{ width: '90%' }}
                value={titleTheme}
                onChange={onChangeThemeTitle}
                placeholder={'Введите заголовок темы'}
              />
              <br />
              <br />
              <label>Цвет:</label>
              <br />
              <br />
              <TwitterPicker
                color={color}
                onChangeComplete={color => onChangeColor(color.hex)}
              />
              <br />
              <button onClick={handleCreateTheme}>
                {selectedThemeId ? 'Сохранить' : 'Добавить'}
              </button>
            </Modal>
            <Modal
              open={statModal}
              onClose={() => setStatModal(false)}
              styles={customModalStyles}
              center={true}
            >
              <h3 style={{ margin: 0, marginBottom: 10 }}>Статистика</h3>
              {courseStatistic ? (
                <ul>
                  <li>
                    Курс: вступило {courseStatistic.all.count} (
                    {courseStatistic.all.percent}%), завершило{' '}
                    {courseStatistic.completed.count} (
                    {courseStatistic.completed.percent}
                    %)
                  </li>
                  <ul>
                    {courseStatistic.modules.map((module, index) => (
                      <li key={`module-${index}`}>
                        {module.title}: вступило {module.all.count} (
                        {module.all.percent}
                        %), завершило {module.completed.count} (
                        {module.completed.percent}
                        %)
                        <ul>
                          {module.lessons.map((lesson, index) => (
                            <li key={`lesson-${index}`}>
                              {lesson.title}: вступило {lesson.all.count} (
                              {lesson.all.percent}%), завершило{' '}
                              {lesson.completed.count} (
                              {lesson.completed.percent}
                              %)
                              <ul>
                                {Array.isArray(lesson.simpleTasks) ? null : (
                                  <li>
                                    {lesson.simpleTasks.caption}: вступило{' '}
                                    {lesson.simpleTasks.all.count} (
                                    {lesson.simpleTasks.all.percent}%),
                                    завершило{' '}
                                    {lesson.simpleTasks.completed.count} (
                                    {lesson.simpleTasks.completed.percent}
                                    %)
                                  </li>
                                )}
                              </ul>
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </ul>
              ) : null}
            </Modal>
          </>
        )}
      </div>
      <Footer />
    </>
  )
}
